// @ts-check
/**
 * Check if Web Share API is supported by the platform.
 *
 * @param {import('./web-share').ShareData} [options]
 * @returns {boolean} Returns `true` if Web Share API is supported; otherwise `false`.
 */ function $442be162a818aed4$export$c37129e465f64ef0(options) {
    if (options !== null && typeof options === "object") return "share" in navigator && "canShare" in navigator && navigator.canShare(options);
    return "share" in navigator;
}


export {$442be162a818aed4$export$c37129e465f64ef0 as isWebShareSupported};
//# sourceMappingURL=is-web-share-supported.js.map
